import React from "react"
import "./styles.scss"

const StepProgressBar = ({currentStep = 0}) => {
  return (
    <div className="step_progress_bar">
      <div
        className="current_status"
        style={{ width: currentStep < 2 ? "40%" : currentStep === 2 ? "80%" : "100%" }}
      />
    </div>
  )
}

export default StepProgressBar
